import React, { useId } from "react";
import styled from "styled-components";
import { HelpText } from "../Styles";

const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 calc(25% - 20px); /* Four fields in a row */
  min-width: calc(25% - 20px);

  @media (max-width: 900px) {
    flex: 1 1 calc(50% - 20px); /* Two fields in a row */
    min-width: calc(50% - 20px);
  }

  @media (max-width: 600px) {
    flex: 1 1 100%; /* One field in a row */
    min-width: 100%;
  }
`;

const CheckboxInputField = styled.div`
  display: flex;
  align-items: center;
`;

const CheckboxLabel = styled.label`
  margin-left: 8px;
  cursor: pointer;
  /* font-size: 14px; */
`;

export const CheckboxInput = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition:
    background-color 0.3s ease,
    border-color 0.3s ease;

  &:checked {
    /* background-color: #007bff; */
    /* border-color: #007bff; */
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

function CheckboxField({ label, helpText = "", checked, onChange }) {
  const id = useId();

  return (
    <CheckboxWrapper>
      <CheckboxInputField>
        <CheckboxInput
          type="checkbox"
          id={id}
          checked={checked}
          onChange={onChange}
        />
        <CheckboxLabel htmlFor={id}>{label}</CheckboxLabel>
      </CheckboxInputField>
      {helpText && <HelpText>{helpText}</HelpText>}
    </CheckboxWrapper>
  );
}

export default CheckboxField;
